import React from 'react';
import { AppBar, Toolbar, Box } from '@mui/material';
import digitalPaaniLogoV2 from '../../../../constants/Images/digitalPaaniLogoV2.png';

const PublicNavbar: React.FC = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: '#193458',
        color: '#fff',
        zIndex: 1201,
      }}
    >
      <Toolbar>
        <Box
          component="img"
          src={digitalPaaniLogoV2}
          alt="Digital Paani Logo"
          sx={{
            maxHeight: '50px',
            width: '110px',
            display: 'block',
          }}
        />
      </Toolbar>
    </AppBar>
  );
};

export default PublicNavbar;
